import { AdmEnhetLight } from '../../../models/admEnhetLight';
import { PaginatedResult, } from '../../../models';
import { getQueryURL } from '../requestService';
import { client } from '../../client';
import { FetchArg } from '../../rtk-queries/queryApiCreator';
import RequestTreeService from '../requestTreeService';

export default class AdmEnhetLightServices extends RequestTreeService<AdmEnhetLight, 'admEnhetLight'> {
  admEnheterLight = async (arg: FetchArg<AdmEnhetLight>) => client.get<PaginatedResult<AdmEnhetLight>>(getQueryURL(`${this.serviceName}/admEnheterLight`, { ...arg.param, disablePagination: arg.disablePagination, q: arg.query }));
  // childrenLight = async (parentId: string) => client.get<AdmEnhetLight[]>(getQueryURL(`${this.serviceName}/${encodeURIComponent(parentId)}/childrenLight`));
  // allTreeItemsLight = async () => client.get<AdmEnhetLight[]>(getQueryURL(`${this.serviceName}/allTreeItemsLight`));


}
